/* eslint-disable no-undef */
$(document).ready(function () {

  // Controllo se esiste il pixel di tracciamento di facebook
  // potrebbe non essere attivo se per esempio non sono stati
  // accettati i relativi cookies di marketing e profilazione
  if (typeof fbq !== 'undefined') {

    // Dettaglio articolo
    if ($('#dettaglio-articolo').length) {

      const fbProductId = $('.criteo-details-itemid').val();
      const fbProductValue = $('#final-price').text()
        .trim()
        .substr(1)
        .replace(/\./g, '')
        .replace(/,/g, '.');

      // Traccio la visita sulla pagina del prodotto
      fbq('track', 'ViewContent', {
        content_ids: fbProductId,
        content_type: 'product'
      });

      // Traccio l'aggiunta al carrello del prodotto
      $('#gtm_addToCart').on('click', function () {
        fbq('track', 'AddToCart', {
          content_ids: fbProductId,
          content_type: 'product',
          currency: 'EUR',
          value: fbProductValue
        });
      });

      // Checkout
    } else if ($('#welldone-wrapper').length) {

      // Leggo il cookie di sessione per vedere se la persona ha già visto
      // la welldone, in caso non l'abbia vista procedo con la funzione.
      const fbqComplete = Cookies.get('fbqComplete');
      if (!fbqComplete) {

        const fbOrderTotal = $('#totale-ordine').text()
          .trim()
          .substr(2)
          .replace(/\./g, '')
          .replace(/,/g, '.');

        const productIds = [];

        $('.product-track').each(function () {
          const pId = $(this).children('.criteo-welldone-id').val();
          const pQty = parseInt($(this).children('.criteo-welldone-qty').val(), 10);
          const pPrice = $(this).children('.criteo-welldone-price').val();
          productIds.push({
            id: pId,
            quantity: pQty,
            item_price: pPrice
          });
        });

        fbq('track', 'Purchase', {
          currency: 'EUR',
          value: fbOrderTotal,
          contents: productIds,
          content_type: 'product'
        });

      }

      Cookies.set('fbqComplete', 'true');

    }
  }
});
